export default __webpack_public_path__ + "static/media/verify.531a909e.png";